import { delay } from "lodash";
import Swal from "sweetalert2";
import { ModuleEvents } from "./Actions";
import { Actions } from "../../internals/app/Actions";
import withReactContent from "sweetalert2-react-content";

export default {
  [ModuleEvents.CREATE_SERVICE_CATEGORY]: ({ dispatch, payload, appState }) => {
    if (payload && !payload.error) {
      dispatch(Actions.common.openAlertBox("CREATE", true, "SUCCESS"));
      delay(() => {
        dispatch(Actions.common.openAlertBox("CREATE", false, "SUCCESS"));
      }, 3000);
    } else {
      return warning("Discount created unsuccessfully!");
    }
  },

  [ModuleEvents.UPDATE_SERVICE_CATEGORY]: ({ dispatch, payload, appState }) => {
    const { result, status } = payload
    const selectedShop = appState.dashboard.get("selectedShop");
    if (result && !result.error) {
      dispatch(Actions.service.fetchCategories(selectedShop.shopId));
      switch (status) {
        case 'CREATE': {
          dispatch(Actions.common.openAlertBox("CREATE", true, "SUCCESS"));
          delay(() => {
            dispatch(Actions.common.openAlertBox("CREATE", false, "SUCCESS"));
          }, 3000);
          return;
        }
        case 'UPDATE': {
          dispatch(Actions.common.openAlertBox("UPDATE", true, "SUCCESS"));
          delay(() => {
            dispatch(Actions.common.openAlertBox("UPDATE", false, "SUCCESS"));
          }, 3000);
          return;
        }
        case 'DELETE': {
          dispatch(Actions.common.openAlertBox("DELETE", true, "SUCCESS"));
          delay(() => {
            dispatch(Actions.common.openAlertBox("DELETE", false, "SUCCESS"));
          }, 3000);
          return;
        }
      }
    } else {
      switch (status) {
        case 'CREATE': {
          return warning("Error occurred while creating the category");
        }
        case 'UPDATE': {
          return warning("Error occurred while updating the category");
        }
        case 'DELETE': {
          return warning("Error occurred while deleting the category");

        }
      }
    }
  },
};

const warning = (alert) => {
  const MySwal = withReactContent(Swal);
  MySwal.fire({
    icon: "error",
    text: alert,
    title: "Oops...",
    showCancelButton: true,
    showConfirmButton: false,
    cancelButtonColor: "#FF3333",
  });
};
